import React from 'react';
import { Home, ChevronDown } from 'lucide-react';
import { UnifiedPropertySelector } from '@/features/properties/components/UnifiedPropertySelector';
import styles from '../Sidebar.module.css';

export const SidebarPropertySelector: React.FC = () => {
  return (
    <div className={styles.propertySelector}>
      <div className={styles.propertySelectorIcon}>
        <Home size={16} />
      </div>
      <div className={styles.propertySelectorDropdown}>
        <UnifiedPropertySelector />
      </div>
      <div className={styles.propertySelectorChevron}>
        <ChevronDown size={16} />
      </div>
    </div>
  );
};
